import React, { useEffect, useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { ApiRoutes } from "../../../constants/apiroutes";
import { Enums } from "../../../constants/enums";
import { APICall } from "../../../services/axiosService";
import { commonService } from "../../../services/common.service";
import { updateLoading } from "../../../store/actions";
import CreateWizardFour from "../Create/CreateWizardFour";
import CreateWizardThree from "../Create/CreateWizardThree";
import CreateWizardTwo from "../Create/CreateWizardTwo";
import AddWizardOne from "./AddWizardOne";

// Create a contract directly from the contract list (without a quotation)
function Add() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authUserDtl = JSON.parse(commonService.getItem("user"));

  const [isCompanyFormClick, setIsCompanyFormClick] = useState(false);
  const [branchData, setBranchData] = useState([]);
  const [durationList, setDurationList] = useState([]);
  const [serviceHoursList, setServiceHoursList] = useState([]);
  const [timezoneList, setTimezoneList] = useState([]);
  const [propertyCategoryList, setPropertyCategoryList] = useState([]);

  const [activeWizard, setActiveWizard] = useState(1);
  const [formInputs, setInput] = useState({
    property_name: "",
    property_category_type: "",
    property_img: "",
    address1: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    latitude: "",
    longitude: "",
    no_of_guards: "",
    no_of_checkpoints: "",
    no_of_patrolling_in_day: "",
    start_date: new Date(),
    timezone: "",
    service_hours_term: "",
    duration_term: "",
    branch_id: "",
    guard_list: [],
    incharge_list: [],
    checkpoint_list: {},
  });
  const [checks, setChecks] = useState([]);
  const [checkJSON, setCheckJSON] = useState([]);

  const [formInputsErrors, setInputErrors] = useState({
    wizOne: {
      property_name: "",
      property_category_type: "",
      address1: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
      no_of_guards: "",
      no_of_checkpoints: "",
      no_of_patrolling_in_day: "",
      start_date: "",
      timezone: "",
      service_hours_term: "",
      duration_term: "",
    },
    wizTwo: {
      guard_list: "",
    },
    wizThree: {
      incharge_list: "",
    },
    wizFour: {},
  });

  const [dataTableLoading, setDataTableLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [companyTotalRows, setGuardTotalRows] = useState(0);
  const [perPageRecords, setPerPageRecords] = useState(
    Enums.DefaultPerPageLength
  );
  const [guardsList, setGuardsList] = useState({
    isData: false,
    data: [],
  });

  const [dataInchargeTableLoading, setInchargeDataTableLoading] =
    useState(false);
  const [inchargePageNo, setInchargePageNo] = useState(1);
  const [inchargeTotalRows, setInchargeTotalRows] = useState(0);
  const [inchargePerPageRecords, setInchargePerPageRecords] = useState(10);
  const [inchargeList, setInchargeList] = useState({
    isData: false,
    data: [],
  });

  const [guardTypes, setGuardTypes] = useState({});

  // Guards & incharges are fetched for the logged in company / branch manager
  let iniFetchGuardAssociation = {
    association_id: authUserDtl?.association_id,
    association_type_term: authUserDtl?.association_type_term,
  };
  const [fetchGuardAssociation, setFetchGuardAssociation] = useState(
    iniFetchGuardAssociation
  );

  const validation_msg = {
    property_name: "This field is required",
    property_category_type: "This field is required",
    address1: "This field is required",
    city: "This field is required",
    state: "This field is required",
    postal_code: "This field is required",
    country: "This field is required",
    no_of_guards: "This field is required",
    no_of_checkpoints: "This field is required",
    no_of_patrolling_in_day: "This field is required",
    start_date: "This field is required",
    service_hours_term: "This field is required",
    duration_term: "This field is required",
    guard_list: "Please select guards",
    incharge_list: "Please select incharge",
    checkpoint: "This field is required",
    timezone: "Please select timezone",
  };

  useEffect(() => {
    getGuardsList("", "", 1);
  }, [pageNo, perPageRecords]);

  useEffect(() => {
    getGuardsList("", "", 1);
    getInchargeList("", "", 1);
  }, [fetchGuardAssociation.association_id]);

  useEffect(() => {
    getInchargeList("", "", 1);
  }, [inchargePageNo, inchargePerPageRecords]);

  useEffect(() => {
    getBranchData();
    getTimeZoneList();
    getQuotationDuration();
    getQuotationServiceHours();
    getPropertyCategoryList();
  }, []);

  const getTimeZoneList = async () => {
    const response = await APICall(ApiRoutes.getTimezoneList);
    if (response.status == 1) {
      setTimezoneList(response.data.list);
      if (response.data.list.length) {
        setInput((prevState) => ({
          ...prevState,
          timezone: response.data.list[0].value,
        }));
      }
    }
  };

  const getBranchData = async () => {
    const response = await APICall(ApiRoutes.BranchDropDownList);
    if (response) {
      setBranchData(response.data.list);
    }
  };

  const getQuotationDuration = async () => {
    const requestMetadata = await APICall(ApiRoutes.QuotationDuration);
    if (requestMetadata) {
      setDurationList(requestMetadata.data.list);
    }
  };

  const getQuotationServiceHours = async () => {
    const requestMetadata = await APICall(ApiRoutes.QuotationServiceHours);
    if (requestMetadata) {
      setServiceHoursList(requestMetadata.data.list);
    }
  };

  const getPropertyCategoryList = async () => {
    const requestMetadata = await APICall(ApiRoutes.PropertyDropdownList);
    if (requestMetadata) {
      setPropertyCategoryList(requestMetadata.data.list.property_category);
    }
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPageRecords(newPerPage);
  };

  async function getGuardsList(column = "", sortDirection = "", isFilter = 0) {
    setDataTableLoading(true);
    setGuardsList({ isData: false, data: [] });
    const requestMetadata = await APICall(ApiRoutes.GuardList, {
      is_all: false,
      page: pageNo,
      is_fixed_association: 1,
      ...fetchGuardAssociation,
      limit: perPageRecords,
      order: { column: column, dir: sortDirection },
      is_filter: isFilter,
      filter: {
        search_text: "",
        start_date: null,
        end_date: null,
        status: 1,
        is_available: 1,
      },
    });

    if (requestMetadata) {
      setGuardsList({
        isData: true,
        data: requestMetadata.data.list,
      });

      let newGuardTypes = {};
      requestMetadata.data.list.forEach((itm) => {
        newGuardTypes = {
          ...newGuardTypes,
          [itm.guard_id]: Enums.GuardTypes.patrolling_guard,
        };
      });
      setGuardTypes(newGuardTypes);

      setGuardTotalRows(requestMetadata.data.total);
    }
    setDataTableLoading(false);
  }

  const handleSort = async (column, sortDirection) => {
    getGuardsList(column.sortField, sortDirection, 1);
  };

  const inchargeHandlePageChange = (page) => {
    setInchargePageNo(page);
  };

  const inchargeHandlePerRowsChange = async (newPerPage, page) => {
    setInchargePerPageRecords(newPerPage);
  };

  async function getInchargeList(
    column = "",
    sortDirection = "",
    isFilter = 0
  ) {
    setInchargeDataTableLoading(true);
    setInchargeList({ isData: false, data: [] });
    const requestMetadata = await APICall(ApiRoutes.InchargeList, {
      is_all: false,
      page: inchargePageNo,
      is_fixed_association: 1,
      ...fetchGuardAssociation,
      limit: inchargePerPageRecords,
      order: { column: column, dir: sortDirection },
      is_filter: isFilter,
      filter: {
        status: 1,
        search_text: "",
        start_date: null,
        end_date: null,
      },
    });

    if (requestMetadata) {
      setInchargeList({ isData: true, data: requestMetadata.data.list });

      setInchargeTotalRows(requestMetadata.data.total);
    }
    setInchargeDataTableLoading(false);
  }

  const inchargeHandleSort = async (column, sortDirection) => {
    getInchargeList(column.sortField, sortDirection, 1);
  };

  const onSelectedRowsChange = (state) => {
    setInput({
      ...formInputs,
      guard_list: state.selectedRows.map((item) => {
        return {
          guard_id: item.guard_id,
        };
      }),
    });
  };

  const onInchargeSelectedRowsChange = (state) => {
    setInput({
      ...formInputs,
      incharge_list: state.selectedRows.map((item) => item.incharge_id),
    });
  };

  function validateForm(wiz) {
    let isValid = true;
    let errors = {};
    const errorKeys = Object.keys(formInputsErrors[wiz]);
    errorKeys.forEach((item) => {
      const value =
        wiz === "wizFour" ? formInputs.checkpoint_list[item] : formInputs[item];
      if (
        value === null ||
        value === undefined ||
        value?.toString().trim() === "" ||
        (Array.isArray(value) && value?.length === 0)
      ) {
        errors[item] =
          wiz === "wizFour" ? validation_msg.checkpoint : validation_msg[item];
        isValid = false;
      } else {
        errors[item] = "";
      }
    });

    setInputErrors((prevState) => ({ ...prevState, [wiz]: errors }));
    return isValid;
  }

  async function submitContractForm(event) {
    event.preventDefault();

    setIsCompanyFormClick(true);
    if (validateForm("wizFour")) {
      dispatch(updateLoading(true));
      let newGuardList = [];

      formInputs.guard_list.forEach((itm) => {
        newGuardList = [
          ...newGuardList,
          {
            ...itm,
            guard_type: guardTypes[itm.guard_id],
          },
        ];
      });
      const requestMetadata = await APICall(ApiRoutes.ContractSaveDirect, {
        property_name: formInputs.property_name,
        property_category_type: formInputs.property_category_type,
        property_img: formInputs.property_img,
        address1: formInputs.address1,
        city: formInputs.city,
        state: formInputs.state,
        postal_code: formInputs.postal_code,
        country: formInputs.country,
        latitude: formInputs.latitude,
        longitude: formInputs.longitude,
        duration_term: formInputs.duration_term,
        service_hours_term: formInputs.service_hours_term,
        no_of_checkpoints: formInputs.no_of_checkpoints,
        no_of_patrolling_in_day: formInputs.no_of_patrolling_in_day,
        guard_list: newGuardList,
        incharge_list: formInputs.incharge_list,
        no_of_guards: formInputs.no_of_guards,
        timezone: formInputs.timezone,
        branch_id: formInputs.branch_id,
        start_date: commonService.convertLocalToUTC(
          commonService.formatDate(formInputs.start_date) + " 00:00:00"
        ),
        checkpoint_list: Object.values(formInputs.checkpoint_list),
      });

      dispatch(updateLoading(false));

      if (requestMetadata) {
        navigate("/contracts");
      }
    }
    setIsCompanyFormClick(false);
  }

  const renderWizardScreen = () => {
    switch (activeWizard) {
      case 1:
        return (
          <AddWizardOne
            formInputs={formInputs}
            formInputsErrors={formInputsErrors.wizOne}
            branchData={branchData}
            setFetchGuardAssociation={setFetchGuardAssociation}
            iniFetchGuardAssociation={iniFetchGuardAssociation}
            durationList={durationList}
            timezoneList={timezoneList}
            serviceHoursList={serviceHoursList}
            propertyCategoryList={propertyCategoryList}
            setInput={(value) => setInput(value)}
            onNextPress={() => {
              if (validateForm("wizOne")) {
                let obj = {};
                for (let i = 1; i <= formInputs.no_of_checkpoints; i++) {
                  obj = { ...obj, ["checkpoint" + i]: "" };
                }
                setInput((prevState) => ({
                  ...prevState,
                  checkpoint_list: obj,
                }));
                setInputErrors((prevState) => ({
                  ...prevState,
                  wizFour: obj,
                }));

                setActiveWizard(2);
              }
            }}
          />
        );
      case 2:
        return (
          <CreateWizardTwo
            formInputs={formInputs}
            formInputsErrors={formInputsErrors.wizTwo}
            guardsList={guardsList}
            setGuardsList={setGuardsList}
            guardTypes={guardTypes}
            setGuardTypes={setGuardTypes}
            dataTableLoading={dataTableLoading}
            companyTotalRows={companyTotalRows}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            handleSort={handleSort}
            setInput={(value) => setInput(value)}
            onNextPress={() => {
              if (validateForm("wizTwo")) {
                setActiveWizard(3);
              }
            }}
            onSelectedRowsChange={onSelectedRowsChange}
            onPreviousPress={() => setActiveWizard(1)}
          />
        );
      case 3:
        return (
          <CreateWizardThree
            checkJSON={checkJSON}
            setCheckJSON={setCheckJSON}
            checks={checks}
            setChecks={setChecks}
            inchargePageNo={inchargePageNo}
            formInputs={formInputs}
            formInputsErrors={formInputsErrors.wizThree}
            inchargeList={inchargeList}
            dataInchargeTableLoading={dataInchargeTableLoading}
            inchargeTotalRows={inchargeTotalRows}
            inchargeHandlePerRowsChange={inchargeHandlePerRowsChange}
            inchargeHandlePageChange={inchargeHandlePageChange}
            inchargeHandleSort={inchargeHandleSort}
            setInput={(value) => setInput(value)}
            onNextPress={() => {
              if (validateForm("wizThree")) {
                setActiveWizard(4);
              }
            }}
            onInchargeSelectedRowsChange={onInchargeSelectedRowsChange}
            onPreviousPress={() => setActiveWizard(2)}
          />
        );
      case 4:
        return (
          <CreateWizardFour
            formInputs={formInputs}
            formInputsErrors={formInputsErrors.wizFour}
            setInput={(value) => setInput(value)}
            onNextPress={(event) => submitContractForm(event)}
            onPreviousPress={() => setActiveWizard(3)}
            isCompanyFormClick={isCompanyFormClick}
          />
        );

      default:
        break;
    }
  };

  return (
    <>
      <div className="row">
        <div className="content-header row">
          <div className="content-header-left col-md-9 col-12 mb-2">
            <div className="breadcrumbs-top d-flex align-items-center">
              <h2 className="content-header-title float-start mb-0">
                Create Contract
              </h2>
              <Breadcrumb className="breadcrumb-chevron">
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/contracts">Contracts</Breadcrumb.Item>
                <Breadcrumb.Item active>Create</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="horizontal-wizard">
            <div className="bs-stepper linear">
              <div className="bs-stepper-header">
                <div className={`step ${activeWizard === 1 ? "active" : ""}`}>
                  <button type="button" className="step-trigger">
                    <span className="bs-stepper-box">1</span>
                    <span className="bs-stepper-label">
                      <span className="bs-stepper-title">Contract Details</span>
                      <span className="bs-stepper-subtitle">
                        Enter Contract Details
                      </span>
                    </span>
                  </button>
                </div>
                <div className="line">
                  <i className="fa-solid fa-angle-right"></i>
                </div>
                <div className={`step ${activeWizard === 2 ? "active" : ""}`}>
                  <button type="button" className="step-trigger">
                    <span className="bs-stepper-box">2</span>
                    <span className="bs-stepper-label">
                      <span className="bs-stepper-title">Assign Guard</span>
                      <span className="bs-stepper-subtitle">
                        Assign Guard to Contract
                      </span>
                    </span>
                  </button>
                </div>
                <div className="line">
                  <i className="fa-solid fa-angle-right"></i>
                </div>
                <div className={`step ${activeWizard === 3 ? "active" : ""}`}>
                  <button type="button" className="step-trigger">
                    <span className="bs-stepper-box">3</span>
                    <span className="bs-stepper-label">
                      <span className="bs-stepper-title">Assign Incharge</span>
                      <span className="bs-stepper-subtitle">
                        Assign Incharge to Contract
                      </span>
                    </span>
                  </button>
                </div>
                <div className="line">
                  <i className="fa-solid fa-angle-right"></i>
                </div>
                <div className={`step ${activeWizard === 4 ? "active" : ""}`}>
                  <button type="button" className="step-trigger">
                    <span className="bs-stepper-box">4</span>
                    <span className="bs-stepper-label">
                      <span className="bs-stepper-title">Checkpoint list</span>
                      <span className="bs-stepper-subtitle">
                        Add Checkpoint list
                      </span>
                    </span>
                  </button>
                </div>
              </div>
              {renderWizardScreen()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
